import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Design system
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.min.css'
import 'boxicons/css/boxicons.min.css'
Vue.use(Vuesax, {
  colors: {
    primary: '#F73859',
    success: 'rgb(23, 201, 100)',
    danger: '#dc3545',
    warning: 'rgb(255, 130, 0)',
    dark: '#283149'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
